
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.822 3.508A6.306 6.306 0 019.032.75c3.494 0 6.326 2.854 6.326 6.375 0 3.52-2.832 6.375-6.326 6.375a6.306 6.306 0 01-5.21-2.758","stroke":"#7D1E36","stroke-width":"1.3","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M8 7.268l1.495 1.518 2.933-3.536M2.33 6h3.777M1.25 8.429h4.857","stroke":"#7D1E36","stroke-width":"1.3","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    